import { render, staticRenderFns } from "./ModalVoltarStatus.vue?vue&type=template&id=e179693e&scoped=true"
import script from "./ModalVoltarStatus.vue?vue&type=script&lang=ts"
export * from "./ModalVoltarStatus.vue?vue&type=script&lang=ts"
import style0 from "./ModalVoltarStatus.vue?vue&type=style&index=0&id=e179693e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e179693e",
  null
  
)

export default component.exports